/* jshint esversion: 6 */
import React from 'react';
import Toggle from 'app/components/common/ToggleControl.jsx';
import HelpButton from 'app/components/common/HelpButton.jsx';
import * as _ from 'underscore';

class ShortenerDetailBitly extends React.Component {
    render() {
        let panelContent = null,
            constants = this.props.app.config.constants,
            connectedMsg = null;

        if (this.props.creds !== '' || this.props.state === 'edit') {
            if (this.props.creds !== '') {
                connectedMsg = (
                    <div className="shortener-connected">
                        Great, We can hook you up! Choose any options that sound useful and hit 'save'.
                    </div>
                )
            }

            // data may not have been set yet after a return from getting creds
            if (_.isEmpty(this.props.data)) {
                return null;
            }

            panelContent = (
                <div>
                    {connectedMsg}
                    <fieldset>
                        <legend>Default</legend>
                        <Toggle
                            active={this.props.convertValueForToggle(this.props.data.default)}
                            callback={this.props.update}
                            linkedField="data.default"
                            noLabel={true}
                            toggleClass="inline" />
                        <span className="form-inline-label light">Use this as the default when sharing manually or setting up new automated sharing.</span>
                    </fieldset>
                    <fieldset>
                        <legend>Send dlvr.it links to bit.ly<HelpButton which="linkWrapper"/></legend>
                        <Toggle
                            active={this.props.convertValueForToggle(this.props.data.wrap)}
                            callback={this.props.update}
                            linkedField="data.wrap"
                            noLabel={true}
                            toggleClass="inline" />
                        <span className="form-inline-label light">Use this option to track your links in both dlvr.it and bit.ly.</span>
                    </fieldset>
                    {this.props.getApplyButtons()}
                    {this.props.getSaveButtons()}
                </div>
            );
        } else {
            panelContent = (
                <div className="shortener-connect-wrapper">
                    <fieldset>
                        <button className="shortener-connect btn-primary fixed active" onClick={this.props.connectService} data-serviceid={constants.SHORTEN_SVC_BITLY}>
                            Connect
                        </button>
                        <span className="form-inline-label light middle">Click the button to start getting your bit.ly account connected to shorten links.<HelpButton which="shortenerBitly"/></span>
                    </fieldset>
                    {this.props.getSaveButtons()}
                </div>
            );
        }

        return panelContent;
    }

};

export default ShortenerDetailBitly;
